<template>
  <div v-loading="loading" element-loading-spinner="particle-loader">
    <template>
      <el-table :data="codingDashboardProjects">
        <el-table-column prop="projectID" label="Project Id"></el-table-column>
        <el-table-column prop="startDate" label="Start Date">
          <template slot-scope="scope">
            {{ formatDate(scope.row.startDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="endDate" label="End Date">
          <template slot-scope="scope">
            {{ formatDate(scope.row.endDate) }}
          </template>
        </el-table-column>
        <el-table-column label="Actions">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleView(scope.row.id)">View</el-button>
          </template>
        </el-table-column>
      </el-table>

    </template>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { format, parseISO } from 'date-fns'

  export default {
    name: 'CodingSchedule',
    // mixins: [HiaAuthorization, money, hiaFilters],
    props: {
      dateRange: { type: Array },
      isOpen: { type: Boolean }
    },
    data: function () {
      return {
        loading: false
      }
    },
    methods: {
      ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS_CODING', 'GET_SCHEDULE_PDF_URL']),
      initialize() {
        this.loading = true
        let param = {
          startDate: this.dateRange[0],
          endDate: this.dateRange[1]
        }
        this.GET_DASHBOARD_PROJECTS_CODING(param).then(response => {
          this.loading = false
        })
      },
      handleView(projectId) {
        const loading = this.$loading({
          lock: true,
          text: 'Getting ready...',
          spinner: 'nucleus-loader',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        this.GET_SCHEDULE_PDF_URL({ projectId: projectId }).then(response => {
          loading.close()
          window.open(`/static/pdfjs/web/viewer.html?file=${response}`, '_blank')
        })
      },
      openPDFViewer(newWindow, worksheet) {
        var byteCharacters = atob(worksheet)
        var byteNumbers = new Array(byteCharacters.length)
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        var blob = new Blob([byteArray], {
          type: 'application/pdf'
        })
        var url = window.URL.createObjectURL(blob)
        var viewerUrl = '/static/pdfjs/web/viewer.html?file=' + encodeURI(url)
        newWindow.location.href = viewerUrl
      },
      formatDate(date) {
        return format(parseISO(date), 'MM/dd/yyyy')
      }
    },
    created: function () {
      this.initialize()
    },
    computed: {
      ...mapState('user/', ['currentClient', 'currentClientId']),
      ...mapState('dashboard/', ['codingDashboardProjects', 'schedule'])
    },
    watch: {
      isOpen() {
        this.initialize()
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
